// extracted by css-extract-rspack-plugin
export default {"list":"list-kUJmqa","link":"link-T2HrMx","active":"active-v5KFW9"};